/* global CLOUDINARY_SHARE */
import React, { PureComponent } from 'react';

import SquareGridThumb from './SquareGridThumb';
import authProtection from '../../HOCs/authProtection';
import withAlertTimeout from '../../HOCs/withAlertTimeout';
import { CLOUDINARY_SHARE } from '../../helpers/cloudinaryConstants';

class SwapImage extends PureComponent {


  constructor(props) {
    super(props);
    this.imageClicked = this.imageClicked.bind(this);

    this.state = {
      image: this.props.image
    };

  }

  imageClicked() {
    if (!this.state.showEdit) {
      this.props.onImageClick(this.props.image.id);
    }
  }


  render() {

    const imgClass = 'album-image img-responsive'
    const thumbImgURL = `${CLOUDINARY_SHARE}/${this.state.image.cloudinaryId}`;

    return (
      <div className="album-item-swap">
        <div className="view-album-grid-item">

          <div className={this.props.currentSelected === this.props.image.id ? "thumb-wrapper-active" : "thumb-wrapper"}>
            <div onClick={this.imageClicked}>
              <SquareGridThumb imgSrc={thumbImgURL} className={imgClass} />
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default authProtection(withAlertTimeout(SwapImage));




// WEBPACK FOOTER //
// ./src/views/Components/SwapImage.js